import forEach from '../../../../javascripts/dom/forEach';
import Slide from './slide';

const slides = document.querySelectorAll('[data-js-module="o-slide"]');

forEach(slides, (index, element) => new Slide(element));
